import type { Board } from "@/model/board";
import type { BoardCard } from "@/model/card";

import { useBoardStore } from "../board";
import { resetCardMark, setSearchCardMark } from "../helpers/mark";
import { CardMatcher } from "./CardMatcher";
import { useSearchMenuStore } from "./searchMenu";

export function matchesCard(board: Board, card: BoardCard): boolean {
  const store = useSearchMenuStore();

  // If there are no search criteria, don't list any results
  // (but don't grey out any cards, either)
  if (!store.anyFilterCriteria) {
    resetCardMark(card);
    return false;
  }
  const cardMatcher = new CardMatcher(store, card);
  const [teamMatch, dependencyTeamFilter] = cardMatcher.teamMatches;
  const typeMatch = cardMatcher.typeMatches(board);

  // link-state filter when the signals flag is off; the risky links signal is matched in signalsMatches
  const linkMatch =
    !useBoardStore().showRiskyLinks ||
    store.selectedRiskyLinks.length === 0 ||
    cardMatcher.explicitLinkMatch(board);
  const propMatch =
    cardMatcher.flagMatches &&
    teamMatch &&
    cardMatcher.iterationMatches &&
    cardMatcher.assigneeMatches &&
    cardMatcher.reporterMatches &&
    cardMatcher.artMatches &&
    typeMatch &&
    cardMatcher.statusMatches &&
    cardMatcher.upperLevelLinksMatches &&
    cardMatcher.statusDistributionMatches &&
    cardMatcher.signalsMatches(board) &&
    linkMatch;
  const isMatch = cardMatcher.textMatches && propMatch;
  // The active sticky stays visible mid-interaction so a chip-driven attribute
  // change that excludes it from the filter doesn't fade or hide it under the
  // user's cursor. The results panel still respects the truthful isMatch.
  const isActive = useBoardStore().activeCardId === card.data.id;
  setSearchCardMark(card, isMatch || isActive, !propMatch && !isActive, dependencyTeamFilter);
  return isMatch;
}
